const vacanciesData = [
    {
        id: "manager",
        position_title: "Менеджер по продажам",
        tasks: [
            "Звонить по холодной и теплой базам (рестораны доставки готовой еды)",
            "Выявлять ЛПР",
            "Узнавать контакты ЛПР",
            "Отправлять сообщения в мессенджерах и по email",
            "Доводить лидов до оплаты",
            "Придерживаться плана по звонкам и новым клиентам",
            "Бережно вести всю работу в AmoCRM",
        ],
        requirements: [
            "Опыт работы 1-3 года",
            "Умеете отстаивать свою точку зрения",
            "Управляетесь с делами быстро и стремительно",
            "Имеете опыт работы с CRM-системами",
            "Можете сами найти информацию в интернете, установить и настроить нужную программу на компьютер"
        ],
        conditions: [
            "Рабочий график: гибкий, но будет время, когда придется работать в офисе с 09:00-10:00 до 18:00-19:00",
            "Возможен удаленный формат работы (формат удаленной работы можно обговорить на собеседовании)",
            "Обучение за счёт компании на период адаптации и в будущем",
            "Команда, готовая помочь и подсказать в любую минуту",
        ],
        image: '/jobs/manager.svg'
    },
    {
        id: "frontend",
        position_title: "Стажер Front-End Разработчик (React)",
        tasks: [
            "Разработка пользовательских интерфейсов для веб-приложений на React",
            "Взаимодействие с командой разработчиков и дизайнеров для реализации новых функций",
            "Тестирование и отладка кода для обеспечения его надежности и эффективности",
            "Участие в code review и соблюдение лучших практик в разработке",
            "Постоянное обучение и улучшение навыков в области front-end разработки"
        ],
        requirements: [
            "Основные знания JavaScript и опыт работы с React",
            "Понимание HTML, CSS и основ веб-дизайна",
            "Желание учиться и быстро осваивать новые технологии",
            "Способность работать в команде и хорошие коммуникативные навыки",
            "Базовое понимание принципов работы Git"
        ],
        conditions: [
            "Полный рабочий день/частичная занятость с гибким графиком",
            "Работа в дружелюбной и поддерживающей команде",
            "Возможность карьерного роста и профессионального развития",
            "Обучающие материалы и менторство от опытных разработчиков"
        ],
        image: '/jobs/frontend.svg'
    },
    {
        id: "backend",
        position_title: "Стажер Backend-Разработчик (Symfony)",
        tasks: [
            "Участие в разработке backend-компонентов веб-приложений на Symfony под руководством опытных разработчиков",
            "Изучение и применение лучших практик программирования и проектирования",
            "Тестирование и отладка кода для обеспечения его качества и надежности",
            "Взаимодействие с другими членами команды для понимания требований к проекту и обмена опытом",
            "Постепенное увеличение уровня сложности задач и ответственности"
        ],
        requirements: [
            "Базовые знания PHP и желание изучать Symfony",
            "Понимание основ программирования и веб-разработки",
            "Готовность учиться и применять новые знания на практике",
            "Способность работать в команде и хорошие коммуникативные навыки",
            "Ответственный подход к задачам и внимание к деталям"
        ],
        conditions: [
            "Гибкий график, подходящий для студентов и начинающих специалистов",
            "Наставничество от опытных разработчиков и поддержка команды",
            "Возможность профессионального роста и развития навыков",
            "Работа над реальными проектами и задачами"
        ],
        image: '/jobs/backend.svg'
    }
];

export default vacanciesData
